export default __webpack_public_path__ + "static/media/logo-no-letters.ad2ebb04.png";